/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "twofactor": {
            "nested": {
              "TwoFactorState": {
                "values": {
                  "NONE": 0,
                  "OPTIONAL": 1,
                  "OPTIONAL_APPS": 2,
                  "REQUIRED": 3
                }
              },
              "PersonTwoFactorStateScope": {
                "nested": {
                  "PersonTwoFactorState": {
                    "values": {
                      "NONE": 0,
                      "REQUIRED": 1
                    }
                  }
                }
              },
              "TwoFactorReasonScope": {
                "nested": {
                  "TwoFactorReason": {
                    "values": {
                      "PERSONAL": 0,
                      "SFS_SAVINGS": 1,
                      "BANKING": 2,
                      "DORMANT_RECOVERY": 3,
                      "MANDATORY": 4
                    }
                  }
                }
              },
              "LegacyTwoFactorSupport": {
                "values": {
                  "ENABLED": 0,
                  "DISABLED": 1,
                  "FORCE_DISABLED": 2
                }
              },
              "TwoFactorDeliveryMethod": {
                "values": {
                  "SMS": 0,
                  "VOICE": 1
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.twofactor?.nested?.TwoFactorState && !$root.nested?.squareup?.nested?.common?.nested?.twofactor?.nested?.PersonTwoFactorStateScope?.nested?.PersonTwoFactorState && !$root.nested?.squareup?.nested?.common?.nested?.twofactor?.nested?.TwoFactorReasonScope?.nested?.TwoFactorReason && !$root.nested?.squareup?.nested?.common?.nested?.twofactor?.nested?.LegacyTwoFactorSupport && !$root.nested?.squareup?.nested?.common?.nested?.twofactor?.nested?.TwoFactorDeliveryMethod) {
  $root.addJSON(jsonData);
}

/**
 * Represents the state of 2FA for a given employment
 *
 * SOURCE TwoFactorState @ squareup/common/two_factor.proto at 7:1
 */
export const TwoFactorState = $root.lookupEnum('squareup.common.twofactor.TwoFactorState').values;
/**
 * Represents the state of 2FA for a given person.
 *
 * SOURCE PersonTwoFactorStateScope @ squareup/common/two_factor.proto at 22:1
 */
export const PersonTwoFactorStateScope = {};
/**
 * SOURCE PersonTwoFactorState @ squareup/common/two_factor.proto at 23:3
 */
PersonTwoFactorStateScope.PersonTwoFactorState = $root.lookupEnum('squareup.common.twofactor.PersonTwoFactorStateScope.PersonTwoFactorState').values;
/**
 * The reason for a 2FA requirement at the person-level.
 *
 * SOURCE TwoFactorReasonScope @ squareup/common/two_factor.proto at 33:1
 */
export const TwoFactorReasonScope = {};
/**
 * SOURCE TwoFactorReason @ squareup/common/two_factor.proto at 34:3
 */
TwoFactorReasonScope.TwoFactorReason = $root.lookupEnum('squareup.common.twofactor.TwoFactorReasonScope.TwoFactorReason').values;
/**
 * Defines whether applications that are incapable of supporting 2FA are grandfathered in for a
 * merchant.
 *
 * SOURCE LegacyTwoFactorSupport @ squareup/common/two_factor.proto at 67:1
 */
export const LegacyTwoFactorSupport = $root.lookupEnum('squareup.common.twofactor.LegacyTwoFactorSupport').values;
/**
 * Defines the different delivery methods for Phone 2FA.
 *
 * SOURCE TwoFactorDeliveryMethod @ squareup/common/two_factor.proto at 79:1
 */
export const TwoFactorDeliveryMethod = $root.lookupEnum('squareup.common.twofactor.TwoFactorDeliveryMethod').values;